// client\src\pages\producao.jsx

import React, { useState, useEffect, useRef } from 'react';
import styles from '../App.module.css';
import api from '../api/axios';
import { FaTimes } from 'react-icons/fa';
import { FaPen, FaCheckCircle, FaHourglassHalf, FaPencilAlt, FaExternalLinkAlt, FaRegFileAlt } from "react-icons/fa";

import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import '../css/notifications.css';
import { isAuthenticated } from '../index'
import notifications from '../components/notifications';
import ModalFinalizar from "../components/ModalFinalizar";
import ListaFormularios from "../components/ListaFormularios";



function Producao() {

  const [notificationType, setNotificationType] = useState(0);
  const { authenticated, userPermission, userStatus, timestamp, userLogin, userId, userCpf } = isAuthenticated();
  useEffect(() => {
    if (notificationType && notifications[notificationType]) {
      notifications[notificationType]();
      setNotificationType(0);
    }
  }, [notificationType, setNotificationType]);
  /* Variáveis de cadastro PRODUCAO */
  const [nome, setNome] = useState("");
  const [contato, setContato] = useState("");
  const [ClienteId, setClienteId] = useState("");
  const [vendedorProd, setVendedorProd] = useState("");
  /* Variáveis para Filtro */
  const [filtroVendedorProd, setFiltroVendedorProd] = useState(0);
  const [filtroProdutor, setFiltroProdutor] = useState(0);
  const [filtroStatusProd, setFiltroStatusProd] = useState(0);
  const [usersListProd, setUsersListProd] = useState([]);
  const [isModalOpenAguardando, setIsModalOpenAguardando] = useState(false);
  const [isModalOpenFinalizado, setIsModalOpenFinalizado] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [currentUserId, setCurrentUserId] = useState(null);
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const textareaRef = useRef(null);

  const [isModalOpenForm, setIsModalOpenForm] = useState(false);
  const [currentFormContent, setCurrentFormContent] = useState('');
  const [currentFormId, setCurrentFormId] = useState('');

  const [isModalOpenAnalise, setIsModalOpenAnalise] = useState(false);
  const [currentAnaliseContent, setCurrentAnaliseContent] = useState(''); // Conteúdo da análise de perfil

  const [formularios, setFormularios] = useState({});

  const [vendedoresList, setVendedoresList] = useState([]);
  const [produtoresList, setProdutoresList] = useState([]);

  const [clienteDetails, setClienteDetails] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");



  async function getClienteDetails(clienteID) {
    if (!clienteID) {
      console.log("ClienteID é inválido ou não fornecido");
      return; // Retorna antecipadamente se clienteID for inválido
    }
    try {
      const response = await api.get(`/clienteAgiliza/${clienteID}`);
      setClienteDetails(response.data);
      setNome(response.data.Nome);
      setContato(response.data.contato);
    } catch (error) {
      console.error("Error fetching client details", error);
    }
  }
  useEffect(() => {
    getClienteDetails(ClienteId);
  }, [ClienteId]);



async function getUsers() {
  try {
    const res = await api.get(`/usuariosComFormularios?userPermission=${userPermission}&CPF=${userCpf}`);
    const { users } = res.data;

    if (!users || !Array.isArray(users)) {
      console.error('Erro: `users` não é um array válido:', users);
      setUsersListProd([]);
      setFilteredDataProd([]);
      NotificationManager.error('Resposta inválida ao carregar usuários.', 'Erro');
      return;
    }

    setUsersListProd(users);
    setFilteredDataProd(users);

    const formulariosMap = users.reduce((acc, user) => {
      if (user.formularios && Array.isArray(user.formularios)) {
        acc[user.produzirId] = user.formularios;
      } else {
        acc[user.produzirId] = [];
      }
      return acc;
    }, {});
    setFormularios(formulariosMap);
  } catch (error) {
    console.error('Erro ao buscar usuários e formulários:', error);
    NotificationManager.error('Não foi possível carregar usuários e formulários.', 'Erro');
  }
}


  const getVendedoresProdutores = async () => {
    try {
      const resVendedoresProdutores = await api.get('/vendedores-produtores');
      // Verifica se a resposta possui a chave `data`
      if (resVendedoresProdutores.data && Array.isArray(resVendedoresProdutores.data.data)) {
        const users = resVendedoresProdutores.data.data;
        setVendedoresList(users.filter(user => user.is_vendedor === 1));
        setProdutoresList(users.filter(user => user.is_produtor === 1));
      } else {
        console.error('Formato inesperado da resposta:', resVendedoresProdutores.data);
        NotificationManager.error('Erro ao carregar vendedores e produtores.', 'Erro');
      }
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      NotificationManager.error('Erro ao carregar dados.', 'Erro');
    }
  }

  useEffect(() => {
    if (userPermission === 1) {
      setVendedorProd(userStatus);
    }
    if (userPermission === 2) {
      setFiltroProdutor(userStatus);
      setFiltroStatusProd(-2);
    }
    getVendedoresProdutores();
    getUsers(); // Agora inclui usuários e formulários
  }, []);


  const deleteUserProd = async (id) => {
    try {
      const res = await api.post('/deletarProd', {
        id: id
      });
      if (res.data.status === true) {
        const newItems = usersListProd.filter(item => item.id !== id);
        setUsersListProd(newItems);
        setNotificationType(4);
      } else {
        setNotificationType(5);
      }
    } catch (error) {
      setNotificationType(5);
    }
  }





// Normaliza removendo acento, pontuação e caixa
const normalize = (text) =>
  (text ?? "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // remove acentos
    .replace(/[^\p{L}\p{N}]+/gu, "") // remove pontuação/espaços (unicode)
    .toLowerCase();

// Achata qualquer objeto/array em uma string única
const flattenValues = (val) => {
  if (val == null) return "";
  if (Array.isArray(val)) return val.map(flattenValues).join(" ");
  if (typeof val === "object") return Object.values(val).map(flattenValues).join(" ");
  return String(val);
};





  const [filteredDataProd, setFilteredDataProd] = useState([]);
  /////////////////////////////////

 useEffect(() => {
  const normalizedSearch = normalize(searchTerm);

  const next = usersListProd.filter((user) => {
    // Status
    const statusMatch =
      filtroStatusProd === 0 ||
      user.produzirStatus == filtroStatusProd ||
      (filtroStatusProd === -2 && (user.produzirStatus == 0 || user.produzirStatus == 2));

    // Vendedor / Produtor
    const vendedorMatch = filtroVendedorProd == 0 || user.vendedor == filtroVendedorProd;
    const produtorMatch = filtroProdutor == 0 || user.produtor == filtroProdutor;

    // Monta um "haystack" gigante com tudo que possa identificar o usuário
    const login = normalize(user.login || "");
    const vendedor = normalize(user.vendedor || "");
    const produtor = normalize(user.produtor || "");
    const nomeCliente = normalize(user.nomeCompleto || user.Nome || "");
    const contatoCliente = normalize(user.contato || "");

    // Formularios
    const forms = Array.isArray(user.formularios) ? user.formularios : [];
    const formsBlob = forms.map((f) => {
      let ds160 = normalize((f.ds160_id ?? "").toString());
      let data = {};
      try { data = JSON.parse(f.formularioData || "{}"); } catch {}
      const flat = normalize(flattenValues(data));
      return [ds160, flat].join(" ");
    }).join(" ");

    // Tudo junto
    const haystack = [login, vendedor, produtor, nomeCliente, contatoCliente, formsBlob].join(" ");

    const searchMatch = !normalizedSearch || haystack.includes(normalizedSearch);

    return statusMatch && vendedorMatch && produtorMatch && searchMatch;
  });

  setFilteredDataProd(next);
}, [usersListProd, filtroVendedorProd, filtroProdutor, filtroStatusProd, searchTerm]);



useEffect(() => {
  // Evita spam: só notifica quando tiver termo de busca ou filtros aplicados
  const someFilterApplied =
    (searchTerm && searchTerm.trim().length > 0) ||
    filtroVendedorProd != 0 ||
    filtroProdutor != 0 ||
    filtroStatusProd != 0;

  if (someFilterApplied && filteredDataProd.length === 0) {
    NotificationManager.info('Nenhum resultado encontrado. Ajuste a busca ou os filtros.', 'Sem resultados');
  }
}, [filteredDataProd, searchTerm, filtroVendedorProd, filtroProdutor, filtroStatusProd]);




  const handleClickAguardando = async (user) => {
    if (user.aguardando) {
      setInputValue(user.aguardando)
    }
    setCurrentUserId(user.produzirId);
    setIsModalOpenAguardando(true);
  };
  const handleClickFinalizado = async (user) => {
    console.log("user YYY", user);

    setCurrentUserId(user.produzirId);
    if (user.aguardando) {
      setInputValue(user.aguardando)
    }
    if (user.login) {
      setLogin(user.login)
    }
    if (user.senha) {
      setSenha(user.senha)
    }
    setIsModalOpenFinalizado(true);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSubmitAguardando = async () => {
    try {
      const response = await api.post('/updateStatusProducao', { id: currentUserId, aguardando: inputValue, status: 2 });
      if (response.status === 200) {
        console.log('Status e texto "aguardando" atualizados com sucesso');
        setIsModalOpenAguardando(false);
        // Atualize a lista de usuários após a atualização
        getUsers();
      } else {
        console.error('Erro ao atualizar o status e o texto "aguardando"');
      }
    } catch (error) {
      console.error('Erro na solicitação de atualização:', error);
    }
  };

  const handleSubmitFinalizado = async () => {
    try {
      const loginStr = login.toString();
      const senhaStr = senha.toString();

      const response = await api.post('/updateStatusProducao', {
        id: currentUserId,
        aguardando: inputValue,
        status: 1,
        login: loginStr,
        senha: senhaStr
      });
      if (response.status === 200) {
        console.log('Status e texto "aguardando" atualizados com sucesso');
        setIsModalOpenFinalizado(false);
        // Atualize a lista de usuários após a atualização
        getUsers();
      } else {
        console.error('Erro ao atualizar o status e o texto "aguardando"');
      }
    } catch (error) {
      console.error('Erro na solicitação de atualização:', error);
    }
  };


  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 400)}px`;
    }
  }, [inputValue]);




  const renderFormContent = (content) => {
    try {
      // Tenta converter o conteúdo em um objeto JSON
      const parsedContent = typeof content === "string" ? JSON.parse(content) : content;

      // Inicializa arrays para perguntas informadas e não informadas
      const informed = [];
      const notInformed = [];

      // Itera sobre as entradas do JSON
      Object.entries(parsedContent).forEach(([key, value]) => {
        const isEmpty =
          value === null ||
          value === undefined ||
          value === "" ||
          (Array.isArray(value) && value.length === 0) ||
          (typeof value === "object" && Object.keys(value).length === 0);

        if (isEmpty) {
          notInformed.push(key); // Adiciona a pergunta ao array de "Não informado"
        } else {
          const displayValue = Array.isArray(value)
            ? value.join(", ")
            : typeof value === "object"
              ? JSON.stringify(value)
              : value;

          informed.push(
            <div key={key} style={{ marginBottom: "10px" }}>
              <strong>{key}:</strong> {displayValue}
            </div>
          );
        }
      });

      return (
        <div>
          {/* Renderiza as perguntas informadas */}
          <div>
            <h3>Informações Preenchidas</h3>
            {informed.length > 0 ? informed : <p>Nenhuma informação preenchida.</p>}
          </div>

          {/* Renderiza as perguntas não informadas */}
          {notInformed.length > 0 && (
            <div style={{ marginTop: "20px", padding: "10px", border: "1px solid #ccc", borderRadius: "5px" }}>
              <h3>Perguntas Não Informadas</h3>
              {notInformed.map((key) => (
                <div key={key} style={{ marginBottom: "5px" }}>
                  <strong>{key}</strong>
                </div>
              ))}
            </div>
          )}
        </div>
      );
    } catch (error) {
      console.error("Erro ao renderizar conteúdo do formulário:", error);
      return <div>Erro ao exibir o conteúdo</div>;
    }
  };
  // Cores fixas para alternar entre os grupos
  const groupColors = ['#8BAED3', '#F29098', '#808EA3', '#C0ECAE'];

  return (
    <div className={styles.app}>
      <NotificationContainer />
      <div style={{ width: "100%", maxWidth: "600px", display: "flex", marginBottom: "-40px" }}>
        <div className="filter-box" style={{ width: "15%", display: "flex", padding: "20px", alignItems: "center" }}>
          <label style={{ width: "100%", fontWeight: "600", fontSize: "1.2rem" }}>FILTRO:</label>
        </div>
        <div className="filter-box" style={{ width: "85%", display: "block", padding: "20px", alignItems: "center" }}>
          <div className="filter-container" style={{ width: "100%", display: "flex", justifyContent: "space-evenly" }}>
            <div className="filter-box" style={{ width: "45%", display: "block" }}>
              <select
                style={{ width: "100%", padding: "10px", borderRadius: "15px", backgroundColor: "white" }}
                onChange={(e) => {
                  console.log('Vendedor selecionado:', e.target.value);
                  setFiltroVendedorProd(e.target.value)
                }}
                value={filtroVendedorProd}
                className={styles.inputStyleVendedor}
              >
                <option value="">Vendedor</option>
                {vendedoresList.map((v) => (
                  <option key={v.id} value={v.cpf}>
                    {v.nome} - {v.cpf}
                  </option>
                ))}
              </select>
            </div>
            <div className="filter-box" style={{ width: "45%", display: "block" }}>
              <select
                style={{ width: "100%", padding: "10px", borderRadius: "15px", backgroundColor: "white" }}
                onChange={(e) => {
                  console.log('Produtor selecionado:', e.target.value);
                  setFiltroProdutor(e.target.value);
                }}
                value={filtroProdutor}
                className={styles.inputStyleVendedor}
              >
                <option value="">Produtor</option>
                {produtoresList.map((p) => (
                  <option key={p.id} value={p.cpf}>
                    {p.nome} - {p.cpf}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.cadastroClienteContainer}>


        <div className="search-container" style={{ width: "100%", textAlign: "center" }}>
          <input
            type="text"
            placeholder="Buscar usuário..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: "80%",
              padding: "10px",
              borderRadius: "20px",
              border: "1px solid #000",
              fontSize: "16px",
              backgroundColor: "#e0e0e0"
            }}
          />
        </div>

        <div style={{ width: "100%", display: "flex" }}>

          <div className="filter-box" style={{ width: "100%", display: "block", padding: "20px", alignItems: "center" }}>




            <select style={{ width: "100%", padding: "10px", borderRadius: "15px", backgroundColor: "#e0e0e0" }} value={filtroStatusProd} onChange={(e) => setFiltroStatusProd(e.target.value)}>
              <option value="0"> Ativos </option>
              <option value="2"> Aguardando </option>
              <option value="1"> Finalizados </option>


            </select>
          </div>
        </div>
        <div style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "space-evenly" }}>
          <div className={styles.topLegend} style={{ backgroundColor: "var(--corPrimaria)" }}>
            <topLegend>
              ID DS-160
            </topLegend>
          </div>
          <div className={styles.topLegend} style={{ backgroundColor: "#df022e" }}>
            <topLegend>
              NOME
            </topLegend>
          </div>
          <div className={styles.topLegend} style={{ backgroundColor: "var(--corPrimaria)" }}>
            <topLegend>
              DATA
            </topLegend>
          </div>
        </div>
        <div style={{ display: "flex", width: "100%" }}>
          <div className={`${styles.usersListContainer} ${styles.noscroll}`}>

            <ListaFormularios
              users={filteredDataProd.filter(user => user.status !== 1)}
              groupColors={groupColors}
              onClickVer={(user) => window.location.href = `${origin}/formularios/${user.clienteId}`}
              onClickFinalizar={handleClickFinalizado}
              onClickAguardar={handleClickAguardando}
              onClickAnalise={(user) => {/* Se quiser modal de análise, exibe modal aqui */ }}
              setCurrentFormContent={setCurrentFormContent}
              setCurrentFormId={setCurrentFormId}
              setIsModalOpenForm={setIsModalOpenForm}
              tipo="pendencias" // ou "producao"
            />


          </div>
        </div>
      </div>
      {isModalOpenAguardando && (
        <div className={styles.modalProducao}>
          <div className={styles.modalContentProducao}>
            <h2>Observação do produtor</h2>
            <textarea
              ref={textareaRef}
              style={{ width: "100%", minHeight: "50px", maxHeight: "400px", overflow: "auto", resize: "none" }}
              value={inputValue}
              onChange={handleInputChange}
            />
            <button onClick={handleSubmitAguardando}>Registrar</button>
            <button onClick={() => { setIsModalOpenAguardando(false); setInputValue("") }}>Fechar</button>
          </div>
        </div>
      )}
      {isModalOpenAnalise && (
        <div className={styles.modalProducaoForm}>
          <div className={styles.modalContentProducaoForm}>
            <div className={styles.closeForm} onClick={() => setIsModalOpenAnalise(false)}>&times; Fechar</div>
            <h2>Conteúdo da Análise de Perfil</h2>
            <p>{currentAnaliseContent}</p>
          </div>
        </div>
      )}
      {isModalOpenForm && (
        <div className={styles.modalProducaoForm}>
          <div className={styles.modalContentProducaoForm}>
            <div className={styles.closeForm} onClick={() => setIsModalOpenForm(false)}><FaTimes /> Fechar</div>
            <a href={`${origin}/preencher/${currentFormId}`}>
              <div className={styles.closeForm} style={{ backgroundColor: "var(--corOn)", color: 'black' }}><FaPen />   Editar</div>
            </a>
            <h2>Conteúdo da DS-160</h2>
            <p>Form ID: {currentFormId}</p>
            {/* <p>{currentFormContent}</p> */}
            <div>{renderFormContent(currentFormContent)}</div>
          </div>
        </div>
      )}


      <ModalFinalizar
        open={isModalOpenFinalizado}
        onClose={() => setIsModalOpenFinalizado(false)}
        onSubmit={handleSubmitFinalizado}
        login={login}
        setLogin={setLogin}
        senha={senha}
        setSenha={setSenha}
        inputValue={inputValue}
        setInputValue={setInputValue}
        textareaRef={textareaRef}
      />







    </div>
  );
}

export default Producao;